import {Injectable, Injector} from '@angular/core';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {SiteService} from '../services/site.service';

@Injectable({providedIn: 'root'})
export class CustomTitleStrategy extends TitleStrategy {
  private restaurantName = '';
  private isInitialized = false;

  constructor(
    private readonly title: Title,
    private injector: Injector
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);

    if (!this.isInitialized) {
      const siteService = this.injector.get(SiteService);
      siteService.getConfiguration().subscribe(res => {
        this.restaurantName = res.body?.data?.name || '';
        this.isInitialized = true;
        this.applyTitle(title);
      });
    }

    this.applyTitle(title);
  }

  private applyTitle(pageTitle: string | undefined) {
    if (pageTitle !== undefined) {
      this.title.setTitle(`${pageTitle} - ${this.restaurantName}`);
    } else if (this.restaurantName) {
      this.title.setTitle(this.restaurantName);
    }
  }
}
